<script setup lang="ts">
import { useUiStore } from '@/stores/useUiStore'
import Toast from './Toast.vue'

const uiStore = useUiStore()

function handleClose(id: string) {
  uiStore.hideToast(id)
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="uiStore.hasToasts"
      class="fixed top-4 right-4 z-[100] flex flex-col gap-2"
    >
      <TransitionGroup name="toast">
        <Toast
          v-for="toast in uiStore.activeToasts"
          :key="toast.id"
          :toast="toast"
          @close="handleClose"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
